export default "__VITE_ASSET__mjPKhzeO__"